import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";

import { useDialog } from "@datanac/datanac-mui-toolkit";
import { IconButton, useMediaQuery } from "@mui/material";
import { getUnitOfMeasureAbbreviation } from "components/Budget/BudgetService";
import { formatNumber, formatPrice } from "utility/formatters";

import { TilleyCard } from "../../Cards/TilleyCard";
import { CropIcon, DeleteIcon } from "../../Icons/Icons";

export default function BudgetCountyCard({ budgetCountyPractice, onChange }) {
  const { component: confirmDialogComponent, actions: confirmDialogActions } = useDialog();

  const isSmall = useMediaQuery((theme) => theme.breakpoints.down("md"), { noSsr: true });

  const navigate = useNavigate();
  const { budget_id } = useParams();

  const [unitOfMeasureAbbreviation, setUnitOfMeasureAbbreviation] = useState(null);

  useEffect(() => {
    _getUnitOfMeasureAbbreviation(budgetCountyPractice);
  }, [budgetCountyPractice]);

  const _getUnitOfMeasureAbbreviation = async (countyPractice) => {
    const _unitOfMeasureAbbreviation = (await getUnitOfMeasureAbbreviation(countyPractice)) || "";
    setUnitOfMeasureAbbreviation(_unitOfMeasureAbbreviation);
  };

  const handleDeleteOnClick = () => {
    confirmDialogActions.confirm({
      title: "Delete this entry?",
      prompt: "Are you sure you want to delete this entry?",
      promptDetail: null,
      callback: () => {
        const _newState = { ...budgetCountyPractice };
        _newState.is_active = false;
        onChange?.(_newState);
      },
    });
  };

  const perAcreMultiplier =
    budgetCountyPractice?.reported_acreage === 0 ? 0 : 1 / budgetCountyPractice?.reported_acreage;

  const details = [
    {
      label: "NET INCOME",
      value:
        formatPrice(
          (budgetCountyPractice?.revenue_simple - budgetCountyPractice?.production_cost) * perAcreMultiplier,
          0
        ) + " / ac",
    },
    {
      label: "ACRES",
      value: formatNumber(budgetCountyPractice?.reported_acreage, 0),
    },
    {
      label: "YIELD",
      value: formatNumber(budgetCountyPractice?.yield, 0),
    },
  ];
  if (!isSmall) {
    details.push({
      label: "PRODUCTION",
      value:
        formatNumber(budgetCountyPractice?.yield * budgetCountyPractice?.reported_acreage, 0) +
        " " +
        unitOfMeasureAbbreviation,
    });
  }

  return (
    <>
      <TilleyCard
        data-testid={`Open ${budgetCountyPractice?.commodity_name ?? "-"} ${budgetCountyPractice?.county_name ?? "-"} ${budgetCountyPractice?.state_name ?? "-"} ${budgetCountyPractice?.practice_name ?? "-"} ${budgetCountyPractice?.type_name ?? "-"}`}
        onClick={() => navigate(`/budget/${budget_id}/${budgetCountyPractice.id}`)}
        Avatar={CropIcon}
        title={
          budgetCountyPractice?.commodity_name +
          " " +
          (budgetCountyPractice?.practice_name && " \u2013 " + budgetCountyPractice?.practice_name) +
          " " +
          (budgetCountyPractice?.type_name &&
            (budgetCountyPractice?.type_name !== "No Type Specified"
              ? " \u2013 " + budgetCountyPractice?.type_name
              : ""))
        }
        subtitle={budgetCountyPractice.name ?? <>&nbsp;</>}
        action={
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              handleDeleteOnClick();
            }}
          >
            <DeleteIcon />
          </IconButton>
        }
        details={details}
      />
      {confirmDialogComponent}
    </>
  );
}
